import util from '../util'

let controller = 'Reivindicacao'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall', 'post']), {
    Post: function (dto) {
        return util.Axios.Post(controller + "/SolicitarReivindicacao", dto)
    },
    ValidaOrigemChave: function (dto) {
        return util.Axios.GetAll(controller + '/ValidaOrigemChave', dto)
    },
    Cancelar: function (dto) {
        return util.Axios.Post(controller + '/Cancelar', dto)
    }
})
